export const SBC_CATEGORIES = [
    { label: "Players", value: 1 },
    { label: "Upgrades", value: 2 },
    { label: "Challenges", value: 3 },
    { label: "Icons", value: 4 },
    { label: "Foundations", value: 5 },
    { label: "Swaps", value: 6 },
];
export const SBC_SET_SORT_OPTIONS = [
    { label: "Newest", value: "newest" },
    { label: "Expiration", value: "expiration" },
    { label: "Price - Low to High", value: "price-low-to-high" },
    { label: "Price - High to Low", value: "price-high-to-low" },
    { label: "Meta Rating", value: "meta-rating" },
    { label: "Most Upvoted", value: "most-upvoted" },
    { label: "In-progress", value: "in-progress" },
    { label: "Trending", value: "trending" },
];
/**
 * Which of the three lists a set belongs in. Hidden wins over completed: a set
 * you have put away is put away whether or not you finished it. An unlimited
 * set is never completed, because it never runs out.
 */
export const sbcSetStatus = (set) => set.isHidden
    ? "hidden"
    : set.solved && set.repeatabilityMode !== "UNLIMITED"
        ? "completed"
        : "available";
const normalizeString = (str) => str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : "";
export const includesIgnoringAccents = (mainStr, searchStr) => {
    const normalizedMainStr = normalizeString(mainStr).toLocaleLowerCase();
    const normalizedSearchStr = normalizeString(searchStr).toLocaleLowerCase();
    return normalizedMainStr.includes(normalizedSearchStr);
};
/** Client-side name search starts at this many characters. */
export const SEARCH_MIN_CHARS = 3;
export const isSearching = (query) => query.length >= SEARCH_MIN_CHARS;
/** True for every name until the query is long enough to search on. */
export const matchesSearch = (name, query) => !isSearching(query) || includesIgnoringAccents(name, query);
export function applySbcListControls(sets, { categoryId, sort, searchText, platform, favoritesOnly }) {
    // An active search is global: it suspends both the selected category and the
    // favorites filter, searching across every set by name.
    let result;
    if (searchText) {
        result = sets.filter((set) => includesIgnoringAccents(set.name, searchText));
    }
    else {
        result = [...sets];
        if (favoritesOnly) {
            result = result.filter((set) => set.isFavorite);
        }
        if (categoryId !== null) {
            result = result.filter((set) => set.categoryId === categoryId);
        }
    }
    const price = (set) => (platform === "PC" ? set.pcPrice : set.psPrice);
    const upvoteRatio = (set) => {
        const total = (set.upVotes ?? 0) + (set.downVotes ?? 0);
        return total === 0 ? 0 : (set.upVotes ?? 0) / total;
    };
    switch (sort) {
        case "newest":
            result.sort((a, b) => b.startTime - a.startTime);
            break;
        case "expiration":
            result.sort((a, b) => (a.endTime === 0 ? Number.MAX_SAFE_INTEGER : a.endTime) -
                (b.endTime === 0 ? Number.MAX_SAFE_INTEGER : b.endTime));
            break;
        case "price-low-to-high":
            result.sort((a, b) => price(a) - price(b));
            break;
        case "price-high-to-low":
            result.sort((a, b) => price(b) - price(a));
            break;
        case "meta-rating":
            result.sort((a, b) => (b.reward?.metaRating?.metarating ?? 0) -
                (a.reward?.metaRating?.metarating ?? 0));
            break;
        case "most-upvoted":
            result.sort((a, b) => upvoteRatio(b) - upvoteRatio(a));
            break;
        case "in-progress":
            result.sort((a, b) => (a.solvedCount ?? 0) - (b.solvedCount ?? 0));
            break;
        // Sets the backend hasn't scored go last
        case "trending":
            result.sort((a, b) => (b.trendingScore ?? 0) - (a.trendingScore ?? 0));
            break;
    }
    return result;
}
//# sourceMappingURL=sbcListControls.js.map